import { Spinner } from 'office-ui-fabric-react';
import * as React from 'react';

import { DiagnosticsActionStatus } from '../../models';
import { createStructuredSelector, mconnect } from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps, IDafNodeStyles } from '../../types';
import { getDafNodeClassNames, getDafSpinnerStyles } from '../intentGraph.styles';
import { dispatchStartDiagnosticsAction } from '../reducers/dispatchers';
import { getNodeSelector,globalVarsSelector,isDiagnosticActionInProgressSelector, jsonPayloadMetaSelector, sessionIdSelector } from '../reducers/selectors.redux';
import { DiagnosticStatusBar } from './diagnosticStatusBar';


const mapStateToProps = createStructuredSelector({
  node: getNodeSelector,
  sessionId: sessionIdSelector,
  meta: jsonPayloadMetaSelector,
  isDiagnosticsInProgress: isDiagnosticActionInProgressSelector,
  globalVars: globalVarsSelector
});

const mapDispatchToProps = { dispatchStartDiagnosticsAction };
const uuidv4 = require('uuid/v4');

type IDAFNodeProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IStyledComponent<IDafNodeStyles> &
  IConnectedComponentProps &
  IComponentStateProps;

class DAFNodeC extends React.PureComponent<IDAFNodeProps> {
  constructor(props: IDAFNodeProps) {
    super(props);
  }

  public componentDidMount(): void {
    if (
      !!this.props.callbackHandlers.DiagnosticsActionHandler &&
      typeof this.props.callbackHandlers.DiagnosticsActionHandler === 'function'
    ) {
      this.props.dispatchStartDiagnosticsAction(
        this.props.node,
        this.props.callbackHandlers.DiagnosticsActionHandler,
        this.props.callbackHandlers.LogHandler,
        this.props.callbackHandlers.IsUserSignedIn
      );
    }
  }

  public render = (): React.ReactNode => {
    const classNames = getDafNodeClassNames(this.props.styles, {
      theme: this.props.theme,
      stylesFunc: this.props.stylesFunc
    });
    const status = this.props.node.get('diagnosticsActionStatus');
    const dialogId = this.props.node.get('dialogId');
    const showDafStatusBar =
      status === DiagnosticsActionStatus.CompletedSuccessfully || status === DiagnosticsActionStatus.Error;
    return (
      <div className={classNames.dafContainer}>
        {showDafStatusBar && 
          <DiagnosticStatusBar 
            classNames={classNames} 
            node={this.props.node} 
            prefix={'daf'} 
            callbackHandlers={this.props.callbackHandlers}
            stylesFunc={this.props.stylesFunc}
            sessionId={this.props.sessionId}
            meta={this.props.meta}
            theme={this.props.theme}
            globalVars={this.props.globalVars}
            dialogId={dialogId}
          />
        }
        {this._showProgressSpinner() && <Spinner styles={getDafSpinnerStyles(this.props)} />}
      </div>
    );
  };

  private _showProgressSpinner = () => {
    if (this.props.isDiagnosticsInProgress) {
      const actionStatus = this.props.node.get('diagnosticsActionStatus');
      switch (actionStatus) {
        case DiagnosticsActionStatus.CompletedSuccessfully:
        case DiagnosticsActionStatus.Error:
          return false;
        default:
          return true;
      }
    }
    return false;
  };
}

export const DAFNode = mconnect(mapStateToProps, mapDispatchToProps)(styledComponent(DAFNodeC, getDafSpinnerStyles));
